import * as Fields from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import type { ReactNode } from "react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { siteCollection } from "#root/schema/platform/newsrpm-marketplace";
import PageLayout from "./layout";

export default function ({ siteId: id }): ReactNode {
  const navigate = useNavigate();
  const handleDelete = useCallback(() => {
    alert("Site Deleted");
    navigate("/admin/platform/newsrpm-marketplace/site");
  }, [navigate]);

  return (
    <PageLayout title="NewsRPM - Site">
      <section>
        <StandardEditor id={id} collection={siteCollection} onDelete={handleDelete}>
          <Fields.Set name="network">
            <label>Network</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="siteName">
            <label>Site Name</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="url">
            <label>URL</label>
            <Fields.WebsiteURI/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="domain">
            <label>Domain</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="logo">
            <label>Logo URL</label>
            <Fields.WebsiteURI/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="city">
            <label>City</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="state">
            <label>Source ID</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="metaTitle">
            <label>Site Title (parsed)</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="metaDescription">
            <label>Site Description (parsed)</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="lastLinked">
            <label>Last Linked</label>
            <Fields.Timestamp/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="lastValid">
            <label>Last Valid</label>
            <Fields.Timestamp/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="createdAt">
            <label>Created At</label>
            <Fields.Timestamp/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="updatedAt">
            <label>Updated</label>
            <Fields.Timestamp/>
            <Fields.Validity/>
          </Fields.Set>
        </StandardEditor>
      </section>
    </PageLayout>
  );
}
